/* Project Kennel: Learn page interactions. No dependencies. Every block works without JS
   (all content is in the HTML at load); this script only adds filtering, paging and toggles. */
(function () {
  if (window.KennelLearn) return;
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function once(el, key) { if (el['kl_' + key]) return false; el['kl_' + key] = true; return true; }

  // Shared pager: shows `per` of the matching items, builds numbered buttons.
  function makePager(root, getItems, per) {
    var pager = $('[data-kl-pager]', root), showing = $('[data-kl-showing]', root), page = 1;
    function render(reset) {
      if (reset) page = 1;
      var all = getItems.all(), items = getItems.match(), n = Math.max(1, Math.ceil(items.length / per));
      if (page > n) page = n;
      all.forEach(function (el) { el.hidden = true; });
      items.forEach(function (el, i) { el.hidden = !(i >= (page - 1) * per && i < page * per); });
      if (showing) showing.textContent = items.length ? 'Showing ' + ((page - 1) * per + 1) + ' to ' + Math.min(page * per, items.length) + ' of ' + items.length : 'Nothing here yet';
      if (!pager) return;
      pager.innerHTML = '';
      function btn(label, p, cur, dis) {
        var b = document.createElement('button'); b.type = 'button'; b.textContent = label;
        if (cur) b.setAttribute('aria-current', 'page'); if (dis) b.disabled = true;
        b.addEventListener('click', function () { page = p; render(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        pager.appendChild(b);
      }
      btn('← Newer', page - 1, false, page === 1);
      for (var i = 1; i <= n; i++) btn(String(i), i, i === page, false);
      btn('Older →', page + 1, false, page === n);
    }
    return render;
  }

  function initGuides(root) {
    if (!once(root, 'guides')) return;
    var per = +root.dataset.per || 9, tabs = $$('[data-tab]', root), cards = $$('[data-tabs]', root);
    var note = $('[data-kl-note]', root), sheet = $('.kl-sheet', root), cur = 'all';
    var match = function () { return cards.filter(function (c) { return cur === 'all' || c.dataset.tabs.indexOf(' ' + cur + ' ') > -1; }); };
    var render = makePager(root, { all: function () { return cards; }, match: match }, per);
    tabs.forEach(function (t) {
      var id = t.dataset.tab, n = id === 'all' ? cards.length : cards.filter(function (c) { return c.dataset.tabs.indexOf(' ' + id + ' ') > -1; }).length;
      var c = $('span', t); if (c) c.textContent = n;
      t.addEventListener('click', function () {
        cur = id;
        tabs.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        root.style.setProperty('--hub', t.dataset.color || '#623E83');
        if (note) note.textContent = t.dataset.note || '';
        try { var u = new URL(location.href); id === 'all' ? u.searchParams.delete('tab') : u.searchParams.set('tab', t.dataset.slug); history.replaceState(null, '', u); } catch (e) {}
        render(true);
      });
    });
    var want = new URLSearchParams(location.search).get('tab');
    var start = want && tabs.filter(function (t) { return t.dataset.slug === want; })[0];
    if (start) start.click(); else render(true);
  }

  function initQuestion(root) {
    if (!once(root, 'q')) return;
    var opts = $$('[data-opt]', root), reveal = $('[data-kl-reveal]', root), wait = $('[data-kl-wait]', root);
    opts.forEach(function (b) {
      b.addEventListener('click', function () {
        opts.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $('[data-head]', reveal).textContent = b.dataset.head;
        $('[data-head]', reveal).style.color = b.dataset.right === 'true' ? '#2F7D3C' : '#B74558';
        $('[data-react]', reveal).textContent = b.dataset.react;
        reveal.hidden = false; if (wait) wait.hidden = true;
      });
    });
  }

  function initStarter(root) {
    if (!once(root, 'start')) return;
    var paths = $$('[data-path]', root), panels = $$('[data-panel]', root), key = 'kl-starter';
    var done = store.get(key) || {};
    function prog(panel) {
      var ticks = $$('[data-tick]', panel), n = ticks.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; }).length;
      var bar = $('[data-kl-prog]', panel), count = $('[data-kl-count]', panel);
      if (bar) bar.style.width = (ticks.length ? n / ticks.length * 100 : 0) + '%';
      if (count) count.textContent = n + ' of ' + ticks.length + ' read';
    }
    panels.filter(function (p) { return $('[data-tick]', p); }).forEach(function (p) {
      $$('[data-tick]', p).forEach(function (t) {
        var k = t.dataset.tick;
        if (done[k]) { t.setAttribute('aria-pressed', 'true'); t.textContent = '✓'; }
        t.addEventListener('click', function () {
          var on = t.getAttribute('aria-pressed') !== 'true';
          t.setAttribute('aria-pressed', on ? 'true' : 'false'); t.textContent = on ? '✓' : '';
          done[k] = on; store.set(key, done); prog(p);
        });
      });
      prog(p);
    });
    paths.forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.dataset.path;
        paths.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.dataset.panel !== id; });
      });
    });
  }

  function initEvents(root) {
    if (!once(root, 'ev')) return;
    var per = +root.dataset.per || 9, btns = $$('[data-show]', root), cards = $$('[data-type]', root), cur = 'all';
    var match = function () { return cards.filter(function (c) { return cur === 'all' || c.dataset.type === cur; }); };
    var render = makePager(root, { all: function () { return cards; }, match: match }, per);
    btns.forEach(function (b) {
      var id = b.dataset.show, c = $('span', b);
      if (c) c.textContent = id === 'all' ? cards.length : cards.filter(function (x) { return x.dataset.type === id; }).length;
      b.addEventListener('click', function () { cur = id; btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); render(true); });
    });
    render(true);
  }

  function initComics(root) {
    if (!once(root, 'comics')) return;
    var per = +root.dataset.per || 12, cards = $$('[data-strip]', root);
    var render = makePager(root, { all: function () { return cards; }, match: function () { return cards; } }, per);
    render(true);
    var tpl = $('[data-kl-reader-tpl]', root); if (!tpl) return;
    var open = -1, el = null, last = null;
    function show(i) {
      open = i; var c = cards[i];
      if (!el) {
        el = tpl.content.firstElementChild.cloneNode(true); document.body.appendChild(el);
        el.addEventListener('click', function (e) { if (e.target === el) close(); });
        $('[data-close]', el).addEventListener('click', close);
        $('[data-prev]', el).addEventListener('click', function () { if (open > 0) show(open - 1); });
        $('[data-next]', el).addEventListener('click', function () { if (open < cards.length - 1) show(open + 1); });
      }
      el.hidden = false;
      $('[data-img]', el).src = c.dataset.img; $('[data-img]', el).alt = c.dataset.alt;
      $('[data-title]', el).textContent = c.dataset.title; $('[data-date]', el).textContent = c.dataset.date;
      $('[data-n]', el).textContent = 'Strip ' + (i + 1) + ' of ' + cards.length;
      $('[data-url]', el).href = c.dataset.url;
      $('[data-prev]', el).disabled = i === 0; $('[data-next]', el).disabled = i === cards.length - 1;
      $('[data-close]', el).focus();
    }
    function close() { if (el) el.hidden = true; open = -1; if (last) last.focus(); }
    cards.forEach(function (c, i) { c.addEventListener('click', function () { last = c; show(i); }); });
    $$('[data-kl-open-latest]').forEach(function (b) { b.addEventListener('click', function (e) { if (cards.length) { e.preventDefault(); last = b; show(0); } }); });
    document.addEventListener('keydown', function (e) {
      if (open < 0) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft' && open > 0) show(open - 1);
      if (e.key === 'ArrowRight' && open < cards.length - 1) show(open + 1);
    });
  }

  function initMyths(root) {
    if (!once(root, 'myths')) return;
    var cards = $$('.kl-myth', root), score = $('[data-kl-score]', root);
    function tally() { if (score) score.textContent = cards.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; }).length + ' of ' + cards.length + ' flipped'; }
    cards.forEach(function (c) {
      var b = $('b', c), s = $('span', c), k = $('small', c), front = [k.textContent, b.textContent, s.textContent];
      c.addEventListener('click', function () {
        var on = c.getAttribute('aria-pressed') !== 'true';
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        k.textContent = on ? 'The answer' : front[0];
        b.textContent = on ? (c.dataset.v === 'fact' ? 'FACT' : 'MYTH') : front[1];
        s.textContent = on ? c.dataset.why : front[2];
        tally();
      });
    });
    tally();
  }

  // Article: turns the plain article body into the Learn layout.
  function initArticle(root) {
    if (!once(root, 'art')) return;
    var prose = $('[data-kl-prose]', root); if (!prose) return;
    var notes = []; try { notes = JSON.parse(($('[data-kl-notes]', root) || {}).textContent || '[]'); } catch (e) {}
    var shortBox = $('[data-kl-short]', root);
    var kids = Array.prototype.slice.call(prose.children);
    // 1. Short answer: the paragraphs before the first H2 (up to two) unless the editor set one.
    if (shortBox && !shortBox.dataset.filled) {
      var intro = [];
      for (var i = 0; i < kids.length && kids[i].tagName !== 'H2'; i++) if (kids[i].tagName === 'P' && intro.length < 2) intro.push(kids[i]);
      if (intro.length) { var dest = $('[data-kl-short-body]', shortBox); intro.forEach(function (p) { dest.appendChild(p); }); shortBox.hidden = false; }
    }
    // 2. Call-your-vet lists become a warning card.
    $$('h3', prose).forEach(function (h) {
      if (!/^call (your|a) vet/i.test(h.textContent.trim())) return;
      var box = document.createElement('div'); box.className = 'kl-vet';
      h.parentNode.insertBefore(box, h); box.appendChild(h);
      var n = box.nextElementSibling; if (n && (n.tagName === 'UL' || n.tagName === 'OL')) box.appendChild(n);
    });
    // 3. Group the body into sections at each H2, with a margin column.
    kids = Array.prototype.slice.call(prose.children);
    var secs = [], cur = null, h2n = 0;
    kids.forEach(function (k) {
      if (k.tagName === 'H2' || !cur) {
        cur = { el: document.createElement('div'), body: document.createElement('div'), side: document.createElement('div'), h: k.tagName === 'H2' ? k : null, n: k.tagName === 'H2' ? ++h2n : 0 };
        cur.el.className = 'kl-s'; cur.side.className = 'kl-s__m'; cur.el.appendChild(cur.body); cur.el.appendChild(cur.side); secs.push(cur);
      }
      cur.body.appendChild(k);
    });
    prose.innerHTML = ''; secs.forEach(function (s) { prose.appendChild(s.el); });
    // 4. FAQ and sources sections.
    secs.forEach(function (s) {
      if (!s.h) return;
      var t = s.h.textContent.trim();
      if (/^(questions|faq|frequently asked)/i.test(t)) {
        var wrap = document.createElement('div'), d = null; wrap.className = 'kl-faq';
        Array.prototype.slice.call(s.body.children).forEach(function (k) {
          if (k === s.h) return;
          if (k.tagName === 'H3') { d = document.createElement('details'); var sm = document.createElement('summary'); sm.textContent = k.textContent; d.appendChild(sm); d.appendChild(document.createElement('div')); wrap.appendChild(d); k.remove(); if (wrap.children.length === 1) d.open = true; }
          else if (d) d.lastChild.appendChild(k);
        });
        if (wrap.children.length) s.body.appendChild(wrap);
      }
      if (/^sources?$|^references$/i.test(t)) { var src = document.createElement('div'); src.className = 'kl-sources'; while (s.body.firstChild) src.appendChild(s.body.firstChild); s.body.appendChild(src); }
    });
    // 5. Leo & Kiki margin notes (from the theme editor), and the quiet note beside vet warnings.
    var img = root.dataset.char || '';
    secs.forEach(function (s) {
      var mine = notes.filter(function (n) { return +n.after === s.n; });
      mine.forEach(function (n, i) {
        var d = document.createElement('div'); d.className = 'kl-mnote' + (n.who === 'Leo' ? ' kl-mnote--y' : '');
        d.innerHTML = (n.who !== 'Leo' && img ? '<img src="' + img + '" alt="">' : '') + '<span><b></b> </span>';
        d.querySelector('b').textContent = n.who + ':'; d.querySelector('span').appendChild(document.createTextNode(n.text));
        if (i) d.style.marginTop = '20px';
        s.side.appendChild(d);
      });
      if (!mine.length && $('.kl-vet', s.body) && root.dataset.quiet) {
        var q = document.createElement('div'); q.className = 'kl-mnote kl-mnote--quiet'; q.textContent = root.dataset.quiet; s.side.appendChild(q);
      }
    });
    // 6. Contents rail with scroll-spy.
    var toc = $('[data-kl-toc]', root);
    if (toc) {
      var links = [];
      if (shortBox && !shortBox.hidden) { shortBox.id = shortBox.id || 'short-answer'; links.push([shortBox, toc.dataset.short || 'The short answer']); }
      secs.forEach(function (s, i) { if (s.h) { s.h.id = s.h.id || 'section-' + (i + 1); links.push([s.h, s.h.textContent.trim()]); } });
      if (links.length < 2) { toc.closest('nav').hidden = true; root.classList.add('kl-notoc'); }
      links.forEach(function (l) { var a = document.createElement('a'); a.href = '#' + l[0].id; a.textContent = l[1]; toc.appendChild(a); l.push(a); });
      var tb = document.createElement('button'); tb.type = 'button'; tb.className = 'kl-toc-btn'; tb.textContent = 'On this page'; tb.setAttribute('aria-expanded', 'false');
      tb.addEventListener('click', function () { var o = toc.classList.toggle('is-open'); tb.setAttribute('aria-expanded', o ? 'true' : 'false'); });
      toc.insertBefore(tb, toc.firstChild);
      links.forEach(function (l) { l[2].addEventListener('click', function () { toc.classList.remove('is-open'); tb.setAttribute('aria-expanded', 'false'); }); });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (l) { l[2].classList.toggle('is-on', l[0] === e.target); }); });
        }, { rootMargin: '-20% 0px -70% 0px' });
        links.forEach(function (l) { io.observe(l[0]); });
      }
    }
  }

  function initSignup(root) {
    if (!once(root, 'su')) return;
    if (/[?&]customer_posted=true/.test(location.search) || /#kl-signup-ok/.test(location.hash)) { var ok = $('[data-kl-ok]', root); if (ok) ok.hidden = false; }
  }

  // Strip emoji from post titles (several live titles start with one) and sort mixed lists newest first.
  function tidy(scope) {
    var re; try { re = new RegExp('[\\u{1F000}-\\u{1FAFF}\\u{2600}-\\u{27BF}\\u{FE0F}\\u{200D}]', 'gu'); } catch (e) { re = null; }
    if (re) $$('[data-kl-clean]', scope).forEach(function (el) { el.textContent = el.textContent.replace(re, '').replace(/\s{2,}/g, ' ').trim(); });
    $$('[data-kl-sort]', scope).forEach(function (g) {
      if (!once(g, 'sort')) return;
      Array.prototype.slice.call(g.children).sort(function (x, y) { return (y.dataset.date || '').localeCompare(x.dataset.date || ''); }).forEach(function (c) { g.appendChild(c); });
    });
  }

  // Each block is set up on its own, so one failure can't stop the others.
  function safe(fn) { return function (el) { try { fn(el); } catch (e) { if (window.console) console.error('[kennel-learn]', fn.name, e); } }; }
  function init(scope) {
    safe(tidy)(scope);
    [['[data-kl-guides]', initGuides], ['[data-kl-question]', initQuestion], ['[data-kl-starter]', initStarter], ['[data-kl-events]', initEvents],
     ['[data-kl-comics]', initComics], ['[data-kl-myths]', initMyths], ['[data-kl-article]', initArticle], ['[data-kl-signup]', initSignup]]
      .forEach(function (p) { $$(p[0], scope).forEach(safe(p[1])); });
  }
  window.KennelLearn = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
